var map = {
	"./facebookSocials.svg": 5665,
	"./instagramSocials.svg": 2435,
	"./linkedinSocials.svg": 3103,
	"./twitterSocials.svg": 88,
	"./youtubeSocials.svg": 9818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7511;